// src/Components/ShippingForm/ShippingFormLayout.js
import React from "react";
import ShippingFields from "./ShippingFields";

export default function ShippingFormLayout({
  title = "Details",
  subtitle = "",
  form,
  onChange,
  onSubmit,
  saving = false,
  submitText = "Save",
  savingText = "Saving...",
  centered = false,
  card = false,
}) {
  const inner = (
    <div
      style={{
        padding: "32px 24px",
        textAlign: "center",
      }}
    >
      {/* ✅ Title always renders */}
      <h2 style={{ fontSize: 22, fontWeight: 600, margin: "0 0 6px" }}>
        {title}
      </h2>

      {subtitle ? (
        <div style={{ color: "#666", fontSize: 14, marginBottom: 18 }}>
          {subtitle}
        </div>
      ) : null}

      <form onSubmit={onSubmit} style={{ marginTop: 10 }}>
        <ShippingFields form={form} onChange={onChange} />

        <button
          type="submit"
          disabled={saving}
          style={{
            width: "100%",
            maxWidth: 300,
            height: 44,
            padding: "12px",
            marginTop: 20,
            borderRadius: 8,
            color: "#fff",
            fontSize: 15,
            fontWeight: 600,
            cursor: "pointer",
            border: "none",
            background: saving ? "#aaa" : "linear-gradient(90deg, #222, #444)",
            boxShadow: "0 6px 14px rgba(0,0,0,0.12)",
          }}
        >
          {saving ? savingText : submitText}
        </button>
      </form>
    </div>
  );

  const cardWrap = card ? (
    <div
      style={{
        background: "#fff",
        borderRadius: 16,
        boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
        width: "100%",
        maxWidth: 560,
      }}
    >
      {inner}
    </div>
  ) : (
    inner
  );

  if (!centered) return cardWrap;

  return (
    <div
      style={{
        minHeight: "90vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "linear-gradient(135deg, #f9f9f9, #f0f4f7)",
        padding: "40px 20px",
      }}
    >
      {cardWrap}
    </div>
  );
}